import { render, staticRenderFns } from "./jumpingLetters.vue?vue&type=template&id=5094686a&scoped=true&lang=html&"
import script from "./jumpingLetters.vue?vue&type=script&lang=js&"
export * from "./jumpingLetters.vue?vue&type=script&lang=js&"
import style0 from "./jumpingLetters.vue?vue&type=style&index=0&id=5094686a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5094686a",
  null
  
)

export default component.exports